import { Column } from '@simplywallst/ui-core';
import styled, { css } from 'styled-components';

export const HideLiquidatedCheckbox = styled('div')`
  display: flex;
  justify-content: flex-end;
  padding-top: ${({ theme }) => theme.x2spacePx}px;
`;

interface ControlPanelProps {
  provider: boolean;
}

export const ControlPanel = styled('div')<ControlPanelProps>`
  border-top: 1px solid ${({ theme }) => theme.color.whiteRGBA(0.2)};
  padding-top: ${({ theme }) => theme.x2spacePx}px;
  padding-bottom: ${({ theme }) => theme.x2spacePx}px;
  ${({ provider }) =>
    provider &&
    css`
      padding-top: 24px;
    `};
  width: 100%;
`;

export const Footer = styled.div`
  margin-top: 24px;
  > button {
    > svg {
      width: 16px;
      height: 16px;
      margin-bottom: -3px;
      margin-left: 2px;
      * {
        fill: white;
      }
    }
  }
`;

export const ShowAllContainer = styled(Column)`
  padding-top: ${({ theme }) => theme.x2space}rem;
`;
